export class SearchCondition {
  sheet_code: string = ""
  nendo: string = ""
  month: string = ""
  curriculum_id: string = ""
  grade: string = ""
  status: string = ""
  event_code: string = ""
  page: number = 1
  row_count: number =  50
  currentPage: number = 1
}

export class BaseSheet {
  id: number
  sheet_code: string
  nendo: number
  month: number
  name: string
  curriculum_id: number
  grade: number
  level: string
  field_names_completed: boolean
  corretct_image_completed: boolean
  field_positions_completed: boolean
  score_positions_completed: boolean
  explanation_image_completed: boolean
  question_image_completed: boolean
  part1_image_completed: boolean
  field_names_completed_text: string
  corretct_image_completed_text: string
  score_positions_completed_text: string
  explanation_image_completed_text: string
  question_image_completed_text: string
  part1_image_completed_text: string
  is_checked: boolean = false
  event_code: number


  constructor(base_sheet: any){
    this.id = base_sheet.id;
    this.sheet_code = base_sheet.sheet_code;
    this.nendo = base_sheet.nendo;
    this.month = base_sheet.month;
    this.name = base_sheet.name;
    this.curriculum_id = base_sheet.curriculum_id;
    this.grade = base_sheet.grade;
    this.level = base_sheet.level;
    this.field_names_completed = base_sheet.field_names_completed;
    this.corretct_image_completed = base_sheet.corretct_image_completed;
    this.field_positions_completed = base_sheet.field_positions_completed;
    this.score_positions_completed = base_sheet.score_positions_completed;
    this.explanation_image_completed = base_sheet.explanation_image_completed;
    this.question_image_completed = base_sheet.question_image_completed;
    this.part1_image_completed = base_sheet.part1_image_completed;
    this.field_names_completed_text = base_sheet.field_names_completed ? "○" : "-";
    this.corretct_image_completed_text = base_sheet.corretct_image_completed ? "○" : "-";
    this.score_positions_completed_text = base_sheet.score_positions_completed ? "○" : "-";
    this.explanation_image_completed_text = base_sheet.explanation_image_completed ? "○" : "-";
    this.question_image_completed_text = base_sheet.question_image_completed ? "○" : "-";
    this.part1_image_completed_text = base_sheet.part1_image_completed ? "○" : "-";
    this.event_code = base_sheet.event_code;
  }
}